export default __webpack_public_path__ + "static/media/shed-in-progress.5b412961.png";